import { SerializedNodes } from '@ws-ui/craftjs-core';
import { createSelector } from '@reduxjs/toolkit';
import { selectRoot } from '.';

/**
 * Returns all components by tab path.
 * @param tabPath: path of the current tab.
 * @returns object with all components.
 */
export const selectComponentsByPath = (tabPath: string) =>
  createSelector(selectRoot, (root) => {
    const tab = root.tabs.find(({ path }) => path === tabPath);
    const components = tab?.content?.components as SerializedNodes;

    if (!tab || !components) return [];

    return Object.keys(components)?.map((key) => ({
      id: key,
      ...components[key],
    }));
  });
